var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-navigation"},[_c('navigator-side-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }